import Vue from 'vue'
import Router from 'vue-router'
import Home from '../components/home'
import About from '../components/about'
import Group from '../components/group'
import Product from '../components/product'
import Recruit from '../components/recruit'
import Post from '../components/post'
import Apphome from '../components/apphome'
import Series from '../components/Series'
import Login from '../components/login'
import Person from "../components/person"
import Detail from "../components/detail"
import Pay from "../components/pay"
 import Auth from "../components/auth"
 import Refund from "../components/refund"
 import WebUser from "../components/web-user"
 import InfoProtect from "../components/info-protect"
 import Identify from "../components/identify"
 import { EventBus } from '@/eventBus'; // 导入全局事件总线

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/identify',
      component: Identify
    },
    {
      path: '/webuser',
      component: WebUser
    },
    {
      path: '/infoproject',
      component: InfoProtect
    },
    {
      path: '/refund',
      component: Refund
    },
    {
      path: '/auth',
      component: Auth
    },
    {
      path: '/pay',
      component: Pay
    },
    {
      path: '/detail',
      component: Detail
    },
    {
      path: '/person',
      component: Person
    },
    {
      path: '/login',
      component: Login
    },
    {
      path: '/home',
      component: Home
    },
    {
      path: '/about',
      component: About
    },
    // {
    //     path: '/group',
    //     component: Group
    // },
    {
      path: '/product',
      component: Product
    },
    {
      path: '/recruit',
      component: Recruit
    },
    {
      path: '/post',
      component: Post
    },
    {
      path: '/apphome',
      component: Apphome
    },
    {
      path: '/',
      redirect: '/Home'
    },
    {
      path: '/series',
      component: Series
    }
  ]
  
});
// 全局导航守卫
// router.beforeEach((to, from, next) => {
//   if ((from.path === '/refund'||from.path === '/auth')&&to.path !== '/pay') {
//     next('/pay'); // 重定向到 /pay 组件
//   } else {
//      next(); // 继续导航
//    // EventBus.$emit('updateMessage'); // 触发事件
//   }
// });

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js